import { render } from "./NotificationChip.vue?vue&type=template&id=7356426e&scoped=true"
import script from "./NotificationChip.vue?vue&type=script&lang=js"
export * from "./NotificationChip.vue?vue&type=script&lang=js"

import "./NotificationChip.vue?vue&type=style&index=0&id=7356426e&scoped=true&lang=scss"
import "./NotificationChip.vue?vue&type=style&index=1&id=7356426e&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7356426e"]])

export default __exports__